import React, { useState, useRef, useEffect } from 'react'
import {
   Button, Grow, Paper, Popper, ClickAwayListener, MenuList, MenuItem,
   CircularProgress
} from '@mui/material'
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'




export default function FilterDropdown_main_v1({ attributes, collections, collectionId, setCollectionId, financed, setFinancedId, financedId, projects, setProjectsId, projectsId, handleSubItem, selectedSubItems, setSelectedSubItems, selectedCountrySlug, setSelectedCountrySlug, selectedRegionSlug, setSelectedRegionSlug, setMakeRequest, visibilityFilter, setVisibilityFilter, objectsStatus, setObjectsStatus, removeRegion, removeCity, cleanListItem, dateFrom, setDateFrom, dateTo, setDateTo, resetAll, handleActiveFilters, loaders }) {
   const [mainOpen, setMainOpen] = useState(false)
   const [activeSubMenu, setActiveSubMenu] = useState(null)
   const [filteredAttributes, setFilteredAttributes] = useState([])
   const [subMenuReady, setSubMenuReady] = useState(false)

   // const [regionOptions, setRegionOptions] = useState([]);
   // const [cityOptions, setCityOptions] = useState([]);

   const anchorRef = useRef(null)
   const subAnchorRef = useRef(null)

   //додатковий реф на пейпері суб меню,щоб лапати клік
   const subMenuPaperRef = useRef(null);

   //рефи для дейтпікерів,щоб не закривалось меню при виборі дати
   // const dateFromRef = useRef(null);
   // const dateToRef = useRef(null);

   // const selectedCountry = selectedSubItems.find(item => item.slug === 'Country')
   // const selectedRegion = selectedSubItems.find(item => item.slug.includes('Region'))

   // console.log('selectedCountrySlug', selectedCountrySlug)
   // console.log('selectedRegionSlug', selectedRegionSlug)
   // console.log('attributes', attributes)
   // console.log('collections', collections)
   // console.log('filteredAttributes', filteredAttributes)
   // console.log('selectedSubItems', selectedSubItems)
   // console.log('mainOpen', mainOpen) // console.log('selectedSubItems', selectedSubItems)
   // console.log('mainOpen', mainOpen)
   // console.log('collectionId', collectionId)
   // console.log('activeFilters', activeFilters)
   //   для винесення списку міст і регіонів в окремі стани

   // useEffect(() => {
   //    const regionOpts = attributes
   //       .filter(attr => attr.slug.includes('Region'))
   //       .flatMap(attribute =>
   //          attribute.attributeItems.map(elem => ({
   //             ...elem,
   //             attributeId: attribute.id,
   //             attributeSlug: attribute.slug
   //          }))
   //       )
   //       .filter(e => e.attributeSlug.includes(selectedCountrySlug));

   //    const cityOpts = attributes
   //       .filter(attr => attr.slug.includes('Settlement'))
   //       .flatMap(attribute =>
   //          attribute.attributeItems.map(elem => ({
   //             ...elem,
   //             attributeId: attribute.id,
   //             attributeSlug: attribute.slug
   //          }))
   //       )
   //       .filter(e => e.attributeSlug.includes(selectedRegionSlug));

   //    setRegionOptions(regionOpts);
   //    setCityOptions(cityOpts);
   // }, [attributes, selectedCountrySlug, selectedRegionSlug]);
   useEffect(() => {
      const result = [

         {
            key: 'Visibility',
            label: 'Visibility',
            slug: 'Visibility',
            options: [
               { id: 'visible', name: 'Visible', slug: 'Visibility' },
               { id: 'non_visible', name: 'Hidden', slug: 'Visibility' }
            ]
         },
         //Додавання пункту статус
         {
            key: 'Status',
            label: 'Status',
            slug: 'Status',
            options: [
               {
                  id: 'Completed',
                  name: 'Completed',
                  slug: 'Completed',
                  icon: (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_2001_6752)">
                        <path d="M18.3337 9.23355V10.0002C18.3326 11.7972 17.7507 13.5458 16.6748 14.9851C15.5988 16.4244 14.0864 17.4773 12.3631 17.9868C10.6399 18.4963 8.79804 18.4351 7.11238 17.8124C5.42673 17.1896 3.98754 16.0386 3.00946 14.5311C2.03138 13.0236 1.56682 11.2403 1.68506 9.44714C1.80329 7.65402 2.498 5.94715 3.66556 4.58111C4.83312 3.21506 6.41098 2.26303 8.16382 1.867C9.91665 1.47097 11.7505 1.65216 13.392 2.38355M18.3337 3.33355L10.0003 11.6752L7.50033 9.17521" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2001_6752">
                           <rect width="20" height="20" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>)
               },
               {
                  id: 'Pending',
                  name: 'Pending',
                  slug: 'Pending',
                  icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_2001_9098)">
                        <path d="M10.0003 4.99984V9.99984L13.3337 11.6665M18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984Z" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2001_9098">
                           <rect width="20" height="20" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               },
               {
                  id: 'Planned',
                  name: 'Planned',
                  slug: 'Planned',
                  icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_2001_8649)">
                        <path d="M10.0003 18.3332C14.6027 18.3332 18.3337 14.6022 18.3337 9.99984C18.3337 5.39746 14.6027 1.6665 10.0003 1.6665C5.39795 1.6665 1.66699 5.39746 1.66699 9.99984C1.66699 14.6022 5.39795 18.3332 10.0003 18.3332Z" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2001_8649">
                           <rect width="20" height="20" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               }
            ]
         },
         //Додавання пункту статус(верх)
         {
            key: 'Country',
            label: 'Country',
            slug: 'Country',
            options: attributes
               .filter(attr => attr.slug === 'Country').map(attribute => {
                  return attribute.attributeItems.map(elem => {
                     return ({
                        ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                     })
                  })
               }).flat(),
            isLoading: loaders.attributes
         },
         {
            key: 'Region',
            label: 'Region',
            slug: 'Region',
            options:
               // regionOptions
               attributes
                  .filter(attr => attr.slug.includes('Region')).map(attribute => {
                     return attribute.attributeItems.map(elem => {
                        return ({
                           ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                        })
                     })
                  }).flat().filter(e => e.attributeSlug.includes(selectedCountrySlug)),
            isLoading: loaders.attributes,
         },
         {
            key: 'City',
            label: 'City',
            slug: 'Settlement',
            options:
               //  cityOptions

               attributes
                  .filter(attr => attr.slug.includes('Settlement')).map(attribute => {
                     return attribute.attributeItems.map(elem => {
                        return ({
                           ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                        })
                     })
                  }).flat().filter(e => e.attributeSlug.includes(selectedRegionSlug)),
            isLoading: loaders.attributes,

            // .filter(el => {
            //    if (selectedCountrySlug === 'ukraine') {
            //       console.log('el.attributesSlug', el.attributeSlug.includes(selectedRegionSlug))
            //       return el.attributeSlug.includes('Settlement');
            //    } else if (selectedCountrySlug === 'poland') {
            //       // return el.attributeSlug.includes('poland');
            //       return !el.attributeSlug.includes('Settlement')
            //    } else {
            //       return true;
            //    }
            // }),



         },
         {
            key: 'Religion',
            label: 'Religion',
            slug: 'Religion',
            options: attributes
               .filter(attr => attr.slug === 'Religion').map(attribute => {
                  return attribute.attributeItems.map(elem => {
                     return ({
                        ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                     })
                  })
               }).flat(),
            isLoading: loaders.attributes,

         },
         //Вставка material
         {
            key: 'Material',
            label: 'Material',
            slug: 'Material',
            options: attributes
               .filter(attr => attr.slug === 'Material').map(attribute => {
                  return attribute.attributeItems.map(elem => {
                     return ({
                        ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                     })
                  })
               }).flat(),
            isLoading: loaders.attributes,
            // .flatMap(attr => attr.attributeItems || []),
         },

         //Вставка material(верх)
         {
            key: 'Century',
            label: 'Century',
            slug: 'Construction',
            options: attributes
               .filter(attr => attr.slug === 'Construction').map(attribute => {
                  return attribute.attributeItems.map(elem => {
                     return ({
                        ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                     })
                  })
               }).flat(),
            isLoading: loaders.attributes,
            // .flatMap(attr => attr.attributeItems || []),
         },

         //вставка колекцій
         {
            key: 'Collection',
            label: 'Collection',
            slug: 'Collection',
            options: !loaders.collections ? [...collections] : [],
            isLoading: loaders.collections,
         },
         //вставка колекцій(верх)
         //вставка пункту з датами сканування
         {
            key: 'Date_of_start',
            label: 'Scan date',
            slug: 'Date_of_start',
            // options: [...coordinatorAll]
         },
         {
            key: 'Projects',
            label: 'Projects',
            slug: 'Projects_scan',
            options: !loaders.projects ? [...projects] : [],
            isLoading: loaders.projects,
         },
         {
            key: 'Financed',
            label: 'Financed',
            slug: 'Financed',
            options: !loaders.financed ? [...financed] : [],
            isLoading: loaders.financed,
         },
         {
            key: 'Digitalized',
            label: 'Executor',
            slug: 'Digitalized',
            options: attributes
            .filter(attr => attr.slug === 'Digitalized').map(attribute => {
               return attribute.attributeItems.map(elem => {
                  return ({
                     ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                  })
               })
            }).flat(),
            isLoading: loaders.attributes,
         },
         {
            key: 'Technology',
            label: 'Technology used',
            slug: 'Technology',
            options: attributes
            .filter(attr => attr.slug === 'Technology').map(attribute => {
               return attribute.attributeItems.map(elem => {
                  return ({
                     ...elem, attributeId: attribute.id, attributeSlug: attribute.slug, attributeCat: attribute.category
                  })
               })
            }).flat(),
            isLoading: loaders.attributes,
         },
      ];

      setFilteredAttributes(result);
   }, [selectedSubItems, attributes, loaders]);

   useEffect(() => {
      if (!mainOpen) {
         //стани які необхідно скидати для очищення,setMakeRequest потрібен для дат і запиту після очищення
         // setSelectedCountrySlug('')
         // setSelectedRegionSlug('')
         // setSelectedSubItems([])


         // setTimeout(() => setMakeRequest(true), 0
         // )
         // setVisibilityFilter(undefined)
         // setCollectionId(null)
         // setObjectsStatus('')
         // setDateFrom(null)
         // setDateTo(null)
         // setMakeRequest(true)
      } else {
         // setMakeRequest(false)
      }

   }, [mainOpen])

   const handleToggleMain = () => {
      setMainOpen(prev => !prev)
      setActiveSubMenu(null)

      // if (mainOpen) {
      //    setMakeRequest(false)
      // }
      // if (!mainOpen) {
      //    setSelectedCountrySlug('')
      //    setSelectedRegionSlug('')
      //    setSelectedSubItems([])
      //    setTimeout(() => setMakeRequest(true), 0
      //    )
      // }

      // setMainOpen(prev => {
      //    const newOpen = !prev;
      //    setActiveSubMenu(null);

      //    if (!newOpen) {
      //       setMakeRequest(true);
      //    } else {
      //       setSelectedCountrySlug('');
      //       setSelectedRegionSlug('');
      //       setSelectedSubItems([]);
      //       setMakeRequest(false);
      //    }

      //    return newOpen;
      // });

   }
   const handleCloseAll = (e) => {

      const popperEl = document.querySelector('.MuiPickersPopper-root');
      if (
         e.target.closest('.MuiPickersPopper-root') ||
         // popperEl?.contains(e.target) ||
         subMenuPaperRef.current?.contains(e.target)
      ) {

         return
      }
      setMainOpen(false)
      setActiveSubMenu(null)
      // setSelectedCountrySlug('')
      // setSelectedRegionSlug('')

   }



   const onMainMenuMouseEnter = (key) => {

      setActiveSubMenu(key)

      // setTimeout(() => {
      //    setSubMenuReady(true);
      // }, 0);
   };

   useEffect(() => {
      if (activeSubMenu) {
         setSubMenuReady(false);
         const timer = setTimeout(() => {
            setSubMenuReady(true);
         }, 10);
         return () => clearTimeout(timer);
      } else {
         setSubMenuReady(false);
      }
   }, [activeSubMenu]);

   // функція для групування міст після вибору країни

   function groupCitiesInCountryList() {
      const list = {}
   }


   return (
      <div style={{ order: '2' }}>

         <Button className='dropdown-filter-button' ref={anchorRef} variant="outlined" onClick={handleToggleMain}>
            <span>
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
               </svg>
            </span>
            <span className='dropdown-filter-button-text'>Filters</span>
         </Button>


         <Popper
            className='dropdown-custom-popper'
            open={mainOpen}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            // placement='right-end'
            transition
            disablePortal
            modifiers={[
               {
                  name: 'offset',
                  options: {
                     offset: [-100, 10],
                  },
               },
            ]}
         >
            {({ TransitionProps }) => (
               <Grow {...TransitionProps}>
                  <Paper className='dropdown-custom-paper'>

                     <ClickAwayListener
                        onClickAway={(e) => handleCloseAll(e)}
                     >

                        <MenuList autoFocusItem>
                           {filteredAttributes.map(attribute => {

                              const isMainSelected =
                                 (attribute.slug === 'Visibility' && visibilityFilter === 'visible') ||
                                 (attribute.slug === 'Visibility' && visibilityFilter === 'non_visible') ||
                                 (attribute.slug === 'Collection' && collectionId) ||
                                 //
                                 (attribute.slug === 'Financed' && financedId) ||
                                 (attribute.slug === 'Projects_scan' && projectsId) ||
                                  //
                                 (attribute.slug === 'Status' && objectsStatus) ||
                                 //
                                 (attribute.slug === 'Date_of_start' && dateFrom && dateTo) ||
                                 selectedSubItems.some(
                                    item => item.slug === attribute.slug
                                 );
                              // console.log('isMainSelected', isMainSelected)
                              return <MenuItem
                                 // className='main-dropdown-custom-menu-item'
                                 className={`main-dropdown-custom-menu-item ${isMainSelected ? 'selected' : ''}`}
                                 key={attribute.key}
                                 style={{
                                    borderTop: (attribute.slug === 'Country' || attribute.slug === 'Date_of_start') ? '1px solid #eeeef0' : '',
                                    borderBottom: (attribute.slug === 'Settlement' || attribute.slug === 'Technology') ? '1px solid #eeeef0' : ''
                                 }}

                                 ref={attribute.key === activeSubMenu ? subAnchorRef : null}
                                 // onMouseEnter={() => setActiveSubMenu(attribute.key)}
                                 onMouseEnter={() => onMainMenuMouseEnter(attribute.key)}
                                 onMouseLeave={() => {
                                    // activeSubMenu === attribute.key && setActiveSubMenu(null)
                                 }
                                 }
                              >
                                 {attribute.label}
                                 <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <g opacity="0.5">
                                          <path d="M6 12L10 8L6 4" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                       </g>
                                    </svg>
                                 </span>
                              </MenuItem>
                           }

                           )}
                           <MenuItem className='main-dropdown-custom-menu-item' onClick={resetAll}>
                              <span style={{ fontWeight: '700', color: 'black' }}>Reset all</span>
                           </MenuItem>


                        </MenuList>

                     </ClickAwayListener>
                  </Paper>
               </Grow>
            )}
         </Popper>


         {filteredAttributes.map(filter =>
            activeSubMenu === filter.key
               && subAnchorRef.current
               ? (
                  <div key={filter.key}>
                     <Popper
                        className='sub-dropdown-custom-popper'
                        // key={filter.key}
                        open
                        anchorEl={subAnchorRef.current}
                        placement="right-start"
                        // placement='right-end'
                        transition
                        disablePortal
                     >
                        {({ TransitionProps }) => (
                           <Grow {...TransitionProps}>
                              <Paper
                                 className='sub-dropdown-custom-papper'
                                 onMouseEnter={() => setActiveSubMenu(filter.key)}
                                 onMouseLeave={() => {
                                    // setActiveSubMenu(null)
                                 }}
                                 ref={subMenuPaperRef}
                              >
                                 {filter.isLoading && 
                                    <div className='d-flex justify-content-center align-items-center h-75 mt-3'>
                                       <CircularProgress color="inherit" />
                                    </div>}
                                 {/* <div className='sub-dropdown-custom-paper-inner'> */}

                                 {filter.slug !== 'Date_of_start'
                                    && <MenuList className='sub-dropdown-custom-menu' autoFocusItem>

                                       {filter.options.length > 0 && <MenuItem
                                          key={`clean-item ${filter.key}`}
                                          className='sub-dropdown-custom-menu-item'
                                          onClick={() => cleanListItem(filter?.slug)}
                                       >
                                          {filter.slug === 'Status' &&
                                             <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0)">
                                                   <circle cx="10" cy="10" r="8.25" stroke="#434349" strokeWidth="1.5" />
                                                   <line x1="6.5" y1="10" x2="13.5" y2="10" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" />
                                                </g>
                                                <defs>
                                                   <clipPath id="clip0">
                                                      <rect width="20" height="20" fill="white" />
                                                   </clipPath>
                                                </defs>
                                             </svg>
                                          } <span
                                             style={{ marginLeft: filter.slug === 'Status' && '10px' }}
                                          >not set</span>
                                       </MenuItem>}

                                       {filter.options.map(option => {

                                          const isSelected =
                                             (option.slug === 'Visibility' && option.id === visibilityFilter) ||
                                             (filter.slug === 'Collection' && option.id === collectionId) ||
                                             (filter.slug === 'Projects_scan' && option.id === projectsId) ||
                                             (filter.slug === 'Financed' && option.id === financedId) ||
                                             (filter.slug === 'Status' && option.slug === objectsStatus) ||
                                             selectedSubItems.some(
                                                item => item.slug === filter.slug && item.id === option.id
                                             );


                                          return (
                                             <MenuItem
                                                key={option.id}
                                                className={`sub-dropdown-custom-menu-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => {
                                                   handleActiveFilters(filter.slug, filter.label, option.slug, option.name, option.id)
                                                   if (option.slug === 'Visibility') {

                                                      setVisibilityFilter(option.id);
                                                      return
                                                   }
                                                   else if (filter.slug === 'Collection') {
                                                      setCollectionId(option.id)
                                                      return
                                                   }
                                                   else if (filter.slug === 'Financed') {
                                                      setFinancedId(option.id)
                                                      return
                                                   }
                                                   else if (filter.slug === 'Projects_scan') {
                                                      setProjectsId(option.id)
                                                      return
                                                   }
                                                   else if (filter.slug === 'Status') {
                                                      setObjectsStatus(option.slug)
                                                      // handleSubItem(option.id, filter.slug)
                                                      return
                                                   }
                                                   else {
                                                      handleSubItem(option.id, filter.slug, option.attributeCat)

                                                      if (option.attributeSlug === 'Country') {
                                                         setSelectedCountrySlug(option.slug)
                                                         setSelectedRegionSlug('')
                                                         removeRegion(selectedSubItems)
                                                         removeCity(selectedSubItems)

                                                      }
                                                      if (option.attributeSlug.includes('Region')) {
                                                         setSelectedRegionSlug(option.slug)
                                                         removeCity(selectedSubItems)
                                                      }
                                                   }
                                                }
                                             }
                                             >
                                                {(filter.slug === 'Status' && option.icon) && option.icon}<span
                                                   // style={{ marginLeft: '10px' }}
                                                   style={{ marginLeft: filter.slug === 'Status' && '10px' }}
                                                >{option.name}</span>
                                             </MenuItem>
                                          );
                                       })}


                                    </MenuList>}

                                 {
                                    filter.slug === 'Date_of_start' &&

                                    <MenuList className='sub-dropdown-custom-menu' autoFocusItem
                                    // ref={dateFromRef}
                                    >
                                       <LocalizationProvider
                                          dateAdapter={AdapterDayjs}
                                       >
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                             <MenuItem
                                                className='sub-dropdown-custom-menu-item'
                                                onClick={() => {
                                                   setDateFrom(null)
                                                   setDateTo(null)
                                                   setMakeRequest(true)
                                                   // cleanListItem(filter?.slug)
                                                }}
                                             >
                                                clean dates
                                             </MenuItem>
                                             {/* const dateFromRef = useRef(null);
                                             const dateToRef = useRef(null); */}

                                             <MenuItem
                                                // ref={dateFromRef}
                                                // key={`clean-item ${filter.key}`}
                                                className='sub-dropdown-custom-menu-item'
                                             // onClick={() => cleanListItem(filter?.slug)}
                                             >
                                                <DatePicker
                                                   views={['year']}
                                                   label="Date_from"
                                                   value={dateFrom}
                                                   onChange={(newValue) => setDateFrom(newValue)}
                                                   // format="YYYY-MM-DD"
                                                   format='YYYY'
                                                   // maxDate={dateTo ?? undefined}
                                                   maxDate={dateTo ? dayjs(dateTo).subtract(1, 'year') : undefined}
                                                   slotProps={{
                                                      textField: {
                                                         size: 'small',
                                                         fullWidth: true,
                                                         variant: 'standard',
                                                      },
                                                   }}
                                                />
                                             </MenuItem>
                                             <MenuItem
                                                // ref={dateToRef}
                                                // key={`clean-item ${filter.key}`}
                                                className='sub-dropdown-custom-menu-item'
                                             // onClick={() => cleanListItem(filter?.slug)}
                                             >

                                                <DatePicker
                                                   views={['year']}
                                                   label="Date_to"
                                                   value={dateTo}
                                                   onChange={(newValue) => setDateTo(newValue)}
                                                   // format="YYYY-MM-DD"
                                                   format='YYYY'
                                                   // minDate={dateFrom ?? undefined}
                                                   minDate={dateFrom ? dayjs(dateFrom).add(1, 'year') : undefined}
                                                   slotProps={{
                                                      textField: {
                                                         size: 'small',
                                                         fullWidth: true,
                                                         variant: 'standard',
                                                      },
                                                   }}
                                                />
                                             </MenuItem>
                                          </div>
                                       </LocalizationProvider>
                                    </MenuList>
                                 }

                                 {/* </div> */}

                              </Paper>
                           </Grow>
                        )}
                     </Popper>
                  </div>
               ) : null
         )
         }


      </div >
   )
}
